import { memo, type CSSProperties } from "react";
import { useReducedMotion } from "../hooks/useReducedMotion";
import { tokens } from "../styles/tokens";

export interface SkeletonProps {
  width?: number | string;
  height?: number | string;
  borderRadius?: number | string;
  animated?: boolean;
  className?: string;
  style?: CSSProperties;
}

function toCssSize(value: number | string | undefined): string | undefined {
  if (value === undefined) return undefined;
  return typeof value === "number" ? `${value}px` : value;
}

export const Skeleton = memo(function Skeleton({
  width,
  height,
  borderRadius = tokens.radius,
  animated = true,
  className,
  style,
}: SkeletonProps) {
  const reducedMotion = useReducedMotion();
  const showAnimation = animated && !reducedMotion;

  return (
    <div
      aria-hidden="true"
      className={[
        "rsle-skeleton",
        showAnimation ? "rsle-skeleton--animated" : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
      style={{
        width: toCssSize(width),
        height: toCssSize(height),
        borderRadius: toCssSize(borderRadius),
        flexShrink: 0,
        ...style,
      }}
    />
  );
});
